import React from "react";
import "../../assets/Legal.css";
import { useTranslation } from "react-i18next";
import CookiePolicyGreek from "./CookiePolicyGreek";
import CookiePolicy from "./CookiePolicy";

function CookiePolicyScreen() {
  const { i18n } = useTranslation();

  return (
    <div className="legal-container">
      {i18n.language === "el" ? <CookiePolicyGreek /> : <CookiePolicy />}
    </div>
  );
}

export default CookiePolicyScreen;
